import React from "react";

const steps = [
  {
    title: "Welcome to Bellhopt!",
    description: "Let's walk you through setting up your first property and start getting guest orders.",
  },
  {
    title: "Earn Commission Per Order",
    description: "We use Stripe for payouts and payouts only. To start earning please link or setup your Stripe Account.",
  },
  {
    title: "Add Your Properties",
    description: "Click 'Add Property' on the top right to create a Bellhopt link for your guests. To bulk upload properties please use the Bulk Upload button on the top right of your dashboard.",
  },
  {
    title: "Set up Automated Emails",
    description: "Once all of your properties are added setup Automated Emails within your Property Management Software with your Bellhopt URLs.",
  },
  {
    title: "Schedule a Call",
    description: "Need Further Help? Please Book a call if you have any questions or need assistance with onboarding.",
  },
  {
    title: "You're All Set!",
    description: "That’s it! You can now offer Concierge Services for all your guests and earn per order!",
  },
];

function TutorialModal({ step, onNext, onBack, onClose }) {
  const isLastStep = step === steps.length - 1;
  const isFirstStep = step === 0;
  const currentStepNumber = step + 1;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 backdrop-blur-sm">
      <div className="relative w-full max-w-md overflow-hidden rounded-2xl bg-white p-6 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-lg text-gray-500 transition hover:bg-gray-200 hover:text-gray-700"
          aria-label="Close tutorial"
        >
          ×
        </button>

        <div className="mb-6 min-h-[180px] pr-10">
          <div className="mb-4 inline-flex rounded-full bg-red-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-red-500">
            Step {currentStepNumber} of {steps.length}
          </div>

          <h2 className="mb-3 text-2xl font-bold text-gray-900">{steps[step].title}</h2>
          <p className="text-base leading-7 text-gray-600">{steps[step].description}</p>
        </div>

        <div className="mb-6 flex gap-2">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`h-2 rounded-full transition-all duration-200 ${
                index === step ? "w-8 bg-red-500" : "w-2 bg-gray-200"
              }`}
            />
          ))}
        </div>

        <div className="flex items-center justify-between gap-3">
          <button
            onClick={onBack}
            disabled={isFirstStep}
            className={`rounded-lg px-4 py-2.5 text-sm font-medium transition ${
              isFirstStep
                ? "cursor-not-allowed bg-gray-100 text-gray-400"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            Back
          </button>
          {!isLastStep ? (
            <button
              onClick={onNext}
              className="rounded-lg bg-red-500 px-5 py-2.5 text-sm font-semibold text-white shadow-md shadow-red-200 transition hover:bg-red-600"
            >
              Next
            </button>
          ) : (
            <button
              onClick={onClose}
              className="rounded-lg bg-red-500 px-5 py-2.5 text-sm font-semibold text-white shadow-md shadow-red-200 transition hover:bg-red-600"
            >
              Finish
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TutorialModal;
